import { Component, OnInit, Input } from '@angular/core';
import { ZpDataService } from 'src/app/services/zp-data.service';

@Component({
  selector: 'app-file-attachment',
  templateUrl: './file-attachment.component.html',
  styleUrls: ['./file-attachment.component.scss']
})
export class FileAttachmentComponent implements OnInit {
  @Input() public attachments: [{ fileName: string, file: string, deleted?: boolean }];
  @Input() public readOnly: boolean;
  @Input() public filePlanId: boolean;
  public fileUrl;
  public token;
  public server;
  constructor(private ZpDataService: ZpDataService) { }

  async ngOnInit() {
    this.token = await this.ZpDataService.generateFileAuth();
    this.attachments.forEach((a) => {
      a.file = encodeURIComponent(a.file);
      a.deleted = false;
    });
    this.server = this.ZpDataService.getApiUrl();
  }


  async deleteFile(file, itemId) {
    let success = await this.ZpDataService.deleteFile(file, itemId);
    if (success) {
      this.attachments.forEach((a) => {
        if (a.file == file) {
          a.deleted = true;
        }
      });
    }
  }
}
